import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-sign-in-icon',
  templateUrl: './navigation-sign-in.component.html'
})
export class NavigationSignInComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
